function normalizer(data, state = null) {
    const output             = Object.assign({}, data);
          output.brand_id    = parseInt(output.brand_id, 10);
          output.category_id = parseInt(output.category_id, 10);
          output.order       = 0;
    
    
    return output;
}

export {
    normalizer
}


// WEBPACK FOOTER //
// ./src/containers/PopularStores/pipeline.js